<template>
    <div>

    <el-dialog :visible.sync="newDialog" center :close-on-click-modal="true" @close="cancelDialogExport"
        custom-class="dialog_normalsuo dialog_normalExport" :append-to-body="true">
        <div class="detail_cont">
            <h3>Export Fields</h3>
            <div class="flex_center_bettwen companydetal_export_content margin-top20">
                <div class="companydetal_export_left">
                    <p class="margin-left10">
                        <el-input placeholder="Finde a filter…" prefix-icon="el-icon-search" v-model="filterInput">
                        </el-input>
                    </p>
                    <div class="flex_between_box margin-top10">
                        <ul class="companydetal_export_left_partent">
                            <li v-for="(item, index) in detailModuleList" class="flex_center_bettwen"
                                @click="clickShouModuleActive(index)" :class="showMoudle == index ? 'MoudleActivew' : ''"
                                :key="index">
                                <span> {{
                                    item.label }}</span>
                                <i class="el-icon-arrow-right"></i>

                            </li>
                        </ul>
                        <div class="companydetal_export_left_checked ">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                                @change="handleCheckAllChange">All</el-checkbox>
                            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                                <el-checkbox v-for="city in cities" :label="city" :key="city">{{ city }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>
                <div class="companydetal_export_right">
                    <p class="companydetal_export_right-title">
                        Selected Columns ({{ checkedCities.length }})
                    </p>
                    <div class="flex_between_box margin-top10">
                        <ul class=" companydetal_export_right_checked">
                            <li v-for="(item, index) in checkedCities" class="flex_center_bettwen" :key="index">
                                <span> {{
                                    item}}</span>
                                <svg t="1733888388675" style="margin-top: 3px;" @click="deleteShouModuleActive(index)"
                                    class="icon" viewBox="0 0 1024 1024" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" p-id="9598" width="20" height="20">
                                    <path
                                        d="M900.435 310.459c-21.23-50.214-51.645-95.288-90.316-133.96s-83.745-69.084-133.96-90.315c-51.982-21.99-107.167-33.11-164.035-33.11-56.87 0-112.137 11.12-164.12 33.11-50.213 21.147-95.286 51.56-134.042 90.232-38.671 38.672-69.084 83.745-90.317 133.959-21.99 52.066-33.11 107.25-33.11 164.12 0 56.87 11.12 112.137 33.11 164.119 21.232 50.214 51.646 95.285 90.317 133.958 38.672 38.671 83.745 69.084 133.958 90.316 51.983 21.99 107.168 33.11 164.12 33.11 56.869 0 112.053-11.12 164.035-33.11 50.212-21.232 95.286-51.645 133.958-90.316 38.671-38.673 69.085-83.744 90.315-133.958 21.99-51.983 33.112-107.165 33.112-164.12 0.085-56.87-11.036-112.053-33.025-164.035zM686.102 652.852c0 0.083 0 0.083 0 0-11.71 11.71-30.666 11.71-42.376 0l-135.308-134.97L373.366 653.19c-11.71 11.711-30.668 11.711-42.378 0-11.71-11.71-11.795-30.668-0.084-42.461l135.053-135.306-135.39-134.97c-11.71-11.711-11.71-30.667 0-42.378 11.71-11.71 30.667-11.71 42.377 0L508.25 433.128l135.054-135.307c11.71-11.71 30.667-11.71 42.377 0 11.71 11.711 11.71 30.669 0 42.378L550.712 475.421l135.305 135.053c11.796 11.711 11.796 30.751 0.085 42.378z"
                                        p-id="9599" fill="#FF6A6A"></path>
                                </svg>

                            </li>
                        </ul>

                    </div>
                </div>
            </div>
            <div class="flex_center_end margin-top10">
                <span class="margin-right30 contclass" style="font-family: 'DMSans Bold';">Reset Default View</span>
             
        <el-button :disabled="checkedCities.length==0" class="btn_export button-210" @click="ApplyChanges()">Apply Changes</el-button>
            </div>
        </div>

    </el-dialog>
         <el-dialog :visible.sync="exportExcelName" center :close-on-click-modal="true" @close="cancelDialogExportName"
        custom-class="dialog_normalsuo dialog_normalExport" :append-to-body="true">
        <div class="detail_cont ">
            <h3>Export (300 results)</h3>
           <div class="margin-top30 ">
            How many results would you like to export form this search? You may also fefine your search by including additional filter(s).
           </div>
           <div class="flex_center_start_box margin-top30 ">
            <span class="margin-right15">File Name:</span><el-input v-model="exportNameExcel" style="width: 50%;" placeholder="Please enter a file name"></el-input>
           </div>
            <div class="flex_center margin-top30 ">
                <el-button  class="btn_export button-210 btn_exporthui" >Cancel</el-button>
                     <el-button  class="btn_export button-210">Back</el-button>
        <el-button :disabled="exportNameExcel==''" class="btn_export button-210" >Export</el-button>
            </div>
        </div>

    </el-dialog>
    </div>
</template>
<script>
const cityOptions = ['Company Name', 'Native Name', 'Company ID', 'VAT Number', 'Stock Code', 'Listed', 'Registration Date', 'Legal Form', 'Company Type', 'Legal Status'];
export default {
    props: {
        showExport: {
            type: Boolean,
            default: false,
        },
        powerStatus: {
            type: Boolean,
            default: false,
        },
        Company: {
            type: Object,
            default: {},
        },
        companynameen: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            filterInput: '',         //page: this.currentPage
            checkAll: false,
            exportNameExcel:'',
            exportExcelName:false,
            showMoudle: 0,
            checkedCities: ['Company Name', 'Native Name','Stock Code','Registration Date','Legal Status'],
            cities: cityOptions,
            detailModuleList: [
                {
                    label: 'Profile',
                    value: 'Profile'
                },
                {
                    label: 'Ownership - Related Companies',
                    value: 'Ownership - Related Companies'
                },
                {
                    label: 'Management',
                    value: 'Management'
                },
                {
                    label: 'Business Activities - Industry',
                    value: 'Business Activities - Industry'
                },
                {
                    label: 'Business Activities - Import & Export',
                    value: 'Business Activities - Import & Export'
                },
                {
                    label: 'Financials',
                    value: 'Financials'
                },
                {
                    label: 'Publications - News',
                    value: 'Publications - News'
                },
                {
                    label: 'Publications - Sanctions',
                    value: 'Publications - Sanctions'
                },
                {
                    label: 'Credit Opinion',
                    value: 'Credit Opinion'
                },
                {
                    label: 'Market Analysis',
                    value: 'Market Analysis'
                },

            ],
            isIndeterminate: true
        };
    },
    computed: {
        newDialog: {
            get() {
                return this.showExport;
            },
            set(newValue) { },
        },
        companyName: {
            get() {
                return this.companynameen;
            },
            set(newValue) { },
        },
    },
    created() {


    },

    methods: {
        ApplyChanges(){
            this.exportExcelName=true
        },

        // 删除选中
        deleteShouModuleActive(index) {
            this.checkedCities.splice(index, 1)
        },
        // 模块高亮
        clickShouModuleActive(index) {
            this.showMoudle = index
            this.cities = cityOptions.slice(0, index + 1)
        },
        cancelDialogExport() {
            this.newDialog = false
            this.$emit('closExportDialog', false);
        },
        cancelDialogExportName(){
            this.exportExcelName=false
        },
        handleCheckAllChange(val) {
            this.checkedCities = val ? cityOptions : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cities.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
        }


    },
};
</script>
<style scoped>
.detail_cont {}

.companydetal_export_left {
    width: 65%;
    background: #F5F5F5;
    border-radius: 4px;
    height: 560px;
    padding: 10px;
    padding-left: 0px;
}

.companydetal_export_right {
    padding: 10px 10px 10px 30px;

    height: 554px;
    width: 34%;
    background: #F5F5F5;
    border-radius: 4px;
}

.companydetal_export_right-title {
    font-size: 18px;
    color: #1A2332;
    font-family: 'DMSans Bold';
    height: 2.85714286rem;
    line-height: 2.85714286rem;
}

.companydetal_export_left /deep/ .el-input__inner {
    height: 2.85714286rem;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #CCCCCC;
}

.companydetal_export_left_checked {
    max-height: 495px;
    overflow: auto;
    min-width: 38%;
}

.companydetal_export_left_checked /deep/ .el-checkbox {
    display: block;
    margin-bottom: 10px;
    height: 2.85714286rem;
    line-height: 2.85714286rem;
}

.companydetal_export_left_partent {
    flex: 1;
    margin-right: 1.4284714rem;
    border-right: 1px solid #CCCCCC;

}

.companydetal_export_right_checked {
    flex: 1;
}

.companydetal_export_left_partent li {
    padding-right: 10px;
    font-size: 1.285714rem;
    height: 2.85714286rem;
    line-height: 2.85714286rem;
    color: #1A2332;
    margin-bottom: 10px;

    padding-left: 10px;
}

.companydetal_export_right_checked li {
    font-size: 1.285714rem;
    height: 2.85714286rem;
    line-height: 2.85714286rem;
    color: #1A2332;
    margin-bottom: 10px;
}

.MoudleActivew {
    background: #FFFFFF;
    color: #1290C9 !important;
}

.companydetal_export_content {}
</style>
